import React, { useEffect, useState } from 'react';
import { inject, observer } from 'mobx-react';

import Section from '../../../Section/Section';
import Form from '../../../Settings/Form/Form';
import {
  Field, renderSelect,
} from '../../../../utils/formFieldHelper';
import { UNSUPPORTED_FONTS, defaultFonts } from '../../../../utils/constants';
import InteractionsHelper from '../../../../helpers/InteractionsHelper';
import { StoresEnum } from '../../../../stores';

const ChannelDefaultFont = ({ channelStore: { channel, readOnly, updateChannel } }) => {
  const [mappedFonts, setMappedFonts] = useState();

  useEffect(() => {
    const fetchFonts = async () => {
      const resourceList = await InteractionsHelper.getChannelFonts(channel.publisherId);
      const filteredFonts = (resourceList || []).filter(
        font => !UNSUPPORTED_FONTS.includes(font.data.name.toLowerCase()),
      );

      let fonts;
      if (filteredFonts.length) {
        fonts = filteredFonts.map(res => ({
          name: res.name,
          id: res.data.css,
        }));
        fonts.unshift({ name: 'Default', id: '' });
      }

      setMappedFonts(fonts || defaultFonts);
    };

    if (channel.publisherId) {
      fetchFonts();
    }
  }, [channel.publisherId]);

  const renderFields = () => (
    <Field
      name="font"
      label="Select a default font when creating a new creative"
      component={renderSelect(mappedFonts)}
      readOnly={readOnly}
    />
  );

  const onSubmit = data => updateChannel({
    channelDefaults: { ...(channel.channelDefaults || {}), font: data.font || '' },
  });

  return (
    <Section title="DEFAULT FONT">
      <Form
        initialValues={{ font: (channel.channelDefaults && channel.channelDefaults.font) || '' }}
        fields={renderFields()}
        onSubmit={onSubmit}
        hideCancelButton
        hideApproveButton={readOnly}
        approveLabel="Apply"
        approveClass="outlined-secondary"
      />
    </Section>
  );
};

export default inject(StoresEnum.CHANNEL)(observer(ChannelDefaultFont));
